module.exports = __webpack_public_path__ + "static/martha-stories-kibble-70a57c1d63e4c44e1301a6060ca2601a.jpg";